<template>
  <div class="slider" :type="sliderType">
      <div class="slider-images">
        <slideritem  v-for="image in sliderImages" :active="image.id === activeSlideID" transition="fade" :key="image.id" :image="image.image" :title="image.title" :subtitle="image.subtitle" :link="image.link"></slideritem>  
        </div>
      <div class="slider-nav" v-if="sliderImages.length > 1">
          <div v-on:click="changeImage(image.id)" class="slider-nav-item" v-for="image in sliderImages" :key="image.id"><i :class="[image.id === activeSlideID ? classActive : classInactive]" aria-hidden="true"></i></div>
      </div>
  </div>
</template>

<script>
import { SliderConfig } from '../../../config/slider.config'
import slideritem from './SliderItem.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Slider',
  components: {slideritem},
  data(){
      return {
        classActive: SliderConfig.dotNavigationActiveClass,
        classInactive: SliderConfig.dotNavigationInActiveClass,
        intervalTime:SliderConfig.slideInterval,
        interval: '',
       
      }
  },
  computed:{
      ...mapGetters({
      sliderImages : "slider/sliderImages",
      sliderType: "slider/sliderType",
      activeSlideID: "slider/activeSlideID",
      sliderActive: "slider/sliderActive"
    })
  },
  methods: {
      changeImageInterval: function () {
        if(this.sliderActive){
             let id = (this.activeSlideID < this.sliderImages.length -1) ? this.activeSlideID+1 : 0
            console.log("change", id)
            this.$store.commit("slider/SET_ACTIVE_SLIDE_ID", id)

        }
      },
      changeImage:function(id){
         
          this.$store.commit("slider/SET_ACTIVE_SLIDE_ID", id)
          
      }
  },
  created() {
     if(this.sliderActive){ 
        clearInterval(this.interval)
        this.interval = setInterval(function () {
            this.changeImageInterval()
        }.bind(this), this.intervalTime);
      }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/interface/Slider/Slider.vue